import React from "react";
import { PageHeader } from "./About";
import { Shield, Lock, Mail } from "lucide-react";
import { companyInfo } from "../mock";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-2xl font-bold text-knight-navy mb-3">{title}</h2>
    <div className="text-knight-navy/80 leading-relaxed space-y-3 text-[15px]">{children}</div>
  </div>
);

const Privacy = () => (
  <main>
    <PageHeader title="Privacy Policy" subtitle="LEGAL" />
    <section className="py-16">
      <div className="max-w-3xl mx-auto px-4">
        <div className="inline-flex items-center gap-2 bg-knight-navy/5 border border-knight-navy/10 rounded-full px-4 py-1.5 mb-6">
          <Shield size={14} className="text-knight-gold" />
          <span className="text-xs font-semibold tracking-wide text-knight-navy">Last updated: February 2026</span>
        </div>

        <p className="text-knight-navy/75 mb-10 leading-relaxed">
          Knight Credit Consultants ("we," "us," "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, share, and protect information about you when you use our website and services.
        </p>

        <Section title="1. Information We Collect">
          <p>We collect information you provide directly to us, such as your name, email address, phone number, mailing address, date of birth, Social Security number (when required for credit-repair work), credit reports, and payment information.</p>
          <p>We also automatically collect device, browser, IP address, and usage data when you visit our website.</p>
        </Section>

        <Section title="2. How We Use Your Information">
          <p>We use your information to: (a) deliver credit-repair, education, and monitoring services; (b) communicate with you about your account, disputes, and progress; (c) process payments; (d) comply with the Credit Repair Organizations Act (CROA), Fair Credit Reporting Act (FCRA), and applicable state laws; and (e) improve our services.</p>
        </Section>

        <Section title="3. How We Share Your Information">
          <p>We do <strong>not</strong> sell your personal information. We share data only with: (a) the three credit bureaus (Experian, Equifax, TransUnion) and furnishers as part of dispute work; (b) service providers that help us operate (payment processors, hosting, email); (c) law enforcement when legally required.</p>
        </Section>

        <Section title="4. Your Rights">
          <p>You have the right to access, correct, or delete the personal information we hold about you, to opt out of marketing emails, and to cancel services at any time without penalty. California, Virginia, Colorado, Connecticut, and Utah residents have additional rights under state privacy laws.</p>
        </Section>

        <Section title="5. Data Security">
          <p>We use industry-standard encryption (TLS in transit, AES-256 at rest), restricted access controls, and regular security reviews. Payment card data is tokenized and never stored in full on our servers.</p>
        </Section>

        <Section title="6. Children's Privacy">
          <p>Our services are not directed to anyone under 18. We do not knowingly collect information from minors.</p>
        </Section>

        <Section title="7. Changes to This Policy">
          <p>We may update this policy from time to time. Material changes will be posted on this page with an updated "Last updated" date and, where appropriate, communicated by email.</p>
        </Section>

        <Section title="8. Contact Us">
          <div className="bg-slate-50 border border-slate-200 rounded-2xl p-5">
            <p className="flex items-center gap-2 mb-2"><Mail size={16} className="text-knight-gold" /> <a href={`mailto:${companyInfo.email}`} className="font-semibold text-knight-navy hover:text-knight-gold">{companyInfo.email}</a></p>
            <p className="flex items-center gap-2"><Lock size={16} className="text-knight-gold" /> {companyInfo.address}</p>
          </div>
        </Section>
      </div>
    </section>
  </main>
);

export default Privacy;
